// Bento-Gallery: "Mehr anzeigen" für Mobile/Tablet.
// Unter 1024px zeigt CSS via .is-collapsed nur die ersten 4 Bilder. Ein Klick
// entfernt die Klasse → alle Bilder erscheinen, und der Button blendet sich
// per Geschwister-Selektor (.is-collapsed + .ds-gallery-more) selbst aus.
export function init() {
  const buttons = document.querySelectorAll(".ds-gallery-more__btn");
  if (!buttons.length) return;

  buttons.forEach((btn) => {
    const wrap = btn.closest(".ds-gallery-more");
    const grid = wrap && wrap.previousElementSibling;
    if (!grid || !grid.classList.contains("ds-gallery-bento")) return;

    btn.addEventListener("click", () => {
      grid.classList.remove("is-collapsed");
      btn.setAttribute("aria-expanded", "true");
    });
  });
}
